import React from "react";
import Dots from "react-activity/lib/Dots";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import plane from "../../images/plane_icon2.png";
import {
  getMainImage,
  saveImage,
  deleteMainImage,
} from "../../services/brandImageService";
import FormState from "../common/formstate";
import { getManufacturer } from "../../services/manufacturerService";
import { getCurrentUser } from "../../services/authService";

class AddBrandImage extends FormState {
  state = {
    base64TextString: "",
    brand_image: "",
    brand_image_format: "",
    image_width: 0,
    image_height: 0,
    manufacturer: {},
    loaded: true,
    user: {},
  };

  schema = {};

  async componentDidMount() {
    this.setState({ loaded: false });

    const items = this.props.location.pathname.split("/");

    const user = getCurrentUser();
    const manufacturer_id = items[3];
    const manufacturer = await getManufacturer(manufacturer_id);

    if (manufacturer) {
      const img = await getMainImage(manufacturer_id);
      if (img)
        this.setState({
          manufacturer,
          brand_image: img.brand_image,
          brand_image_format: img.brand_image_format,
          image_width: img.image_width,
          image_height: img.image_height,
          user,
          loaded: true,
        });
      else this.setState({ manufacturer, user, loaded: true });
    } else this.setState({ user, loaded: true });
  }

  handleDelete = async (brand_id) => {
    await deleteMainImage(brand_id);
    this.props.history.push(`/manufacturer/details/${brand_id}`);
  };

  handleCancel = (manufacturer_id) => {
    this.props.history.push(`/manufacturer/details/${manufacturer_id}`);
  };

  onFileChange(e) {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 2097152) {
        toast.error("The image is too large to upload. 2MB maximum.");
        e.value = "";
        return;
      }
      const brand_image_format = file.name.split(".").pop();
      this.setState({ brand_image_format });

      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  onImgLoad = ({ target: img }) => {
    this.setState({
      image_height: img.naturalHeight,
      image_width: img.naturalWidth,
    });
  };

  _handleReaderLoaded(readEvt) {
    let binaryString = readEvt.target.result;
    const base64String = btoa(binaryString);

    const format = this.state.brand_image_format;
    const pic = document.getElementById("plane-picture");
    pic.src = "data:image/" + format + ";base64," + base64String;
    pic.width = 300;

    this.setState({ base64TextString: base64String });
  }

  async doSubmit() {
    const {
      base64TextString: base64String,
      brand_image_format,
      image_width,
      image_height,
      manufacturer,
      user,
    } = this.state;

    if (base64String.length > 0) {
      let payload = {};
      payload.brand_image = base64String;
      payload.brand_image_format = brand_image_format;
      payload.image_width = image_width;
      payload.image_height = image_height;
      payload.brand_id = manufacturer.manufacturer_id;
      payload.show_main_image = true;
      payload.owner_id = user.id;

      await saveImage(payload);
    }

    this.props.history.push(
      `/manufacturer/details/${manufacturer.manufacturer_id}`
    );
  }

  render() {
    const { manufacturer, loaded, brand_image, brand_image_format } =
      this.state;

    let img = "";
    if (brand_image)
      img = "data:image/" + brand_image_format + ";base64," + brand_image;
    else img = plane;

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div style={{ padding: "20px", border: "1px solid darkgray" }}>
          <div style={{ marginBottom: "20px" }}>
            <ToastContainer></ToastContainer>
            <h4>
              <FontAwesomeIcon icon="image" />
              &nbsp;Add Logo for brand - {manufacturer.manufacturer_fullname}
            </h4>
          </div>
          <div>
            <form onSubmit={this.handleSubmit}>
              <img
                src={img}
                alt="brand"
                id="plane-picture"
                className="brandFormPhoto"
                onLoad={this.onImgLoad}
                style={{ marginRight: 20, width: 300 }}
              />
              <input
                type="file"
                name="btnBrowse"
                accept=".jpeg, .png, .jpg"
                onChange={(e) => this.onFileChange(e)}
              ></input>
              <div style={{ marginTop: "20px" }}>
                <button className="btn btn-primary">Save</button>&nbsp;
                <Button
                  variant="primary"
                  onClick={() =>
                    this.handleDelete(manufacturer.manufacturer_id)
                  }
                >
                  Delete Logo
                </Button>
                &nbsp;
                <Button
                  variant="primary"
                  onClick={() =>
                    this.handleCancel(manufacturer.manufacturer_id)
                  }
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(AddBrandImage);
